var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDisneyIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 98.582,
    height: 82.295,
    viewBox: "0 0 98.582 82.295",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_42",
    "data-name": "Rect\\xE1ngulo 42",
    width: 98.582,
    height: 82.295,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19",
    "data-name": "Grupo 19",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_84",
    "data-name": "Trazado 84",
    d: "M54.071,23.335l-.169-.816c-.124-.595-.244-1.166-.344-1.743-1.324-7.646,1.856-14.693,8.3-18.391A18.758,18.758,0,0,1,76.334.731L74.981,6.055A13.327,13.327,0,0,0,64.557,7.161C60.1,9.717,58,14.454,58.933,19.832c.088.512.2,1.023.306,1.55l.177.858Z",
    fill: "#fdb54e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_85",
    "data-name": "Trazado 85",
    d: "M.123,25.609C-.607,18.648,1.91,12.335,7.6,6.847A23.627,23.627,0,0,1,21.216.311a17.6,17.6,0,0,1,17.971,8.8,18.184,18.184,0,0,1,1.6,13.084l-5.319-1.224a12.632,12.632,0,0,0-1.059-9.212,12.178,12.178,0,0,0-12.487-6,18.058,18.058,0,0,0-10.546,5.056C6.9,15.129,5,19.777,5.549,25.032Z",
    fill: "#fdb54e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_86",
    "data-name": "Trazado 86",
    d: "M28.343,42.341a16.825,16.825,0,0,1-9.415-.48C13.363,39.785,10.123,35.719,9.5,29.8c-.693-6.619,2-12,6.652-16.488a20.9,20.9,0,0,1,12.08-5.8,14.861,14.861,0,0,1,15.23,7.4,15.448,15.448,0,0,1,1.328,11.148c-.076.335-.156.669-.265,1.138a28.586,28.586,0,0,1,18.883.06c-.175-.871-.357-1.673-.5-2.481C61.8,18.337,64.407,12.39,69.875,9.251A16.071,16.071,0,0,1,82.325,7.872,21.994,21.994,0,0,1,98.4,25.6,14.4,14.4,0,0,1,85.224,42.5a54.741,54.741,0,0,1-5.748-.1C82.352,49.335,83.7,58.1,81.037,65.3a21.47,21.47,0,0,1-2.119,4.135,26.989,26.989,0,0,1-24.8,12.82,30.538,30.538,0,0,1-16.433-5.595A27.244,27.244,0,0,1,26.994,61.249a28.41,28.41,0,0,1,1.35-18.908",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisneyIcon2);
export default __webpack_public_path__ + "static/media/disneyIcon2.058525adc84c3c964cba3c26fbaef9c9.svg";
export { ForwardRef as ReactComponent };